// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Request from "../../core/Request.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Form__Status from "../../bundles/Form/Form__Status.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as AddressComboBoxField from "../../modules/AddressComboBoxField.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

function stripEmptyString(string) {
  switch (string) {
    case "" :
    case " " :
      return;
    default:
      return string;
  }
}

function flatMapOrEmptyString(value, map) {
  return Stdlib_Option.getOr(Stdlib_Option.flatMap(value, map), "");
}

function emptyStringToNull(string) {
  return Stdlib_Option.getOr(stripEmptyString(string), null);
}

let Raw = {};

let query = Client.gql(["fragment SupplierFragment on Supplier   {\n__typename  \nid  \nupdatedAt  \narchivedAt  \ncompanyName  \nintraCommunityVat  \nphoneNumber  \nmobileNumber  \nsiretNumber  \ninternalCode  \nemail  \nnote  \nshop  {\n__typename  \nid  \n}\n\nlocations  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nlabel  \nrecipient  \naddress  \npostalCode  \ncity  \ncountry  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.archivedAt;
  let value$2 = value.intraCommunityVat;
  let value$3 = value.phoneNumber;
  let value$4 = value.mobileNumber;
  let value$5 = value.siretNumber;
  let value$6 = value.internalCode;
  let value$7 = value.email;
  let value$8 = value.note;
  let value$9 = value.shop;
  let value$10 = value.locations;
  let value$11 = value$10.edges;
  return {
    __typename: value.__typename,
    id: value.id,
    updatedAt: Scalar.Datetime.parse(value.updatedAt),
    archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
    companyName: value.companyName,
    intraCommunityVat: !(value$2 == null) ? value$2 : undefined,
    phoneNumber: !(value$3 == null) ? value$3 : undefined,
    mobileNumber: !(value$4 == null) ? value$4 : undefined,
    siretNumber: !(value$5 == null) ? value$5 : undefined,
    internalCode: !(value$6 == null) ? value$6 : undefined,
    email: !(value$7 == null) ? value$7 : undefined,
    note: !(value$8 == null) ? Scalar.Text.parse(value$8) : undefined,
    shop: {
      __typename: value$9.__typename,
      id: value$9.id
    },
    locations: {
      __typename: value$10.__typename,
      edges: value$11.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.recipient;
        let value$3 = value$1.address;
        let value$4 = value$1.postalCode;
        let value$5 = value$1.city;
        let value$6 = value$1.country;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            label: value$1.label,
            recipient: !(value$2 == null) ? value$2 : undefined,
            address: !(value$3 == null) ? value$3 : undefined,
            postalCode: !(value$4 == null) ? value$4 : undefined,
            city: !(value$5 == null) ? value$5 : undefined,
            country: !(value$6 == null) ? value$6 : undefined
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.locations;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.country;
    let country = value$2 !== undefined ? value$2 : null;
    let value$3 = value$1.city;
    let city = value$3 !== undefined ? value$3 : null;
    let value$4 = value$1.postalCode;
    let postalCode = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.address;
    let address = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.recipient;
    let recipient = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.label;
    let value$8 = value$1.id;
    let value$9 = value$1.__typename;
    let node = {
      __typename: value$9,
      id: value$8,
      label: value$7,
      recipient: recipient,
      address: address,
      postalCode: postalCode,
      city: city,
      country: country
    };
    let value$10 = value.__typename;
    return {
      __typename: value$10,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let locations = {
    __typename: value$3,
    edges: edges
  };
  let value$4 = value.shop;
  let value$5 = value$4.id;
  let value$6 = value$4.__typename;
  let shop = {
    __typename: value$6,
    id: value$5
  };
  let value$7 = value.note;
  let note = value$7 !== undefined ? Scalar.Text.serialize(value$7) : null;
  let value$8 = value.email;
  let email = value$8 !== undefined ? value$8 : null;
  let value$9 = value.internalCode;
  let internalCode = value$9 !== undefined ? value$9 : null;
  let value$10 = value.siretNumber;
  let siretNumber = value$10 !== undefined ? value$10 : null;
  let value$11 = value.mobileNumber;
  let mobileNumber = value$11 !== undefined ? value$11 : null;
  let value$12 = value.phoneNumber;
  let phoneNumber = value$12 !== undefined ? value$12 : null;
  let value$13 = value.intraCommunityVat;
  let intraCommunityVat = value$13 !== undefined ? value$13 : null;
  let value$14 = value.companyName;
  let value$15 = value.archivedAt;
  let archivedAt = value$15 !== undefined ? Scalar.Datetime.serialize(value$15) : null;
  let value$16 = value.updatedAt;
  let value$17 = Scalar.Datetime.serialize(value$16);
  let value$18 = value.id;
  let value$19 = value.__typename;
  return {
    __typename: value$19,
    id: value$18,
    updatedAt: value$17,
    archivedAt: archivedAt,
    companyName: value$14,
    intraCommunityVat: intraCommunityVat,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    siretNumber: siretNumber,
    internalCode: internalCode,
    email: email,
    note: note,
    shop: shop,
    locations: locations
  };
}

function verifyArgsAndParse(_SupplierFragment, value) {
  return parse(value);
}

function verifyName(_fragmentName) {
  
}

let SupplierFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

let Raw$1 = {};

let query$1 = Client.gql([
  "query SupplierQuery($id: ID!)  {\nsupplier(id: $id)  {\n...SupplierFragment   \n}\n\n}\n",
  ""
], query);

function parse$1(value) {
  let value$1 = value.supplier;
  return {
    supplier: !(value$1 == null) ? parse(value$1) : undefined
  };
}

function serialize$1(value) {
  let value$1 = value.supplier;
  let supplier = value$1 !== undefined ? serialize(value$1) : null;
  return {
    supplier: supplier
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let SupplierQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});

let use = include.use;

let SupplierQuery_refetchQueryDescription = include.refetchQueryDescription;

let SupplierQuery_useLazy = include.useLazy;

let SupplierQuery_useLazyWithVariables = include.useLazyWithVariables;

let SupplierQuery = {
  SupplierQuery_inner: SupplierQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: SupplierQuery_refetchQueryDescription,
  use: use,
  useLazy: SupplierQuery_useLazy,
  useLazyWithVariables: SupplierQuery_useLazyWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql([
  "mutation updateSupplier($id: ID!, $supplierInput: InputUpdateSupplier!, $locationsInput: [InputUpdateOrCreateSupplierLocation!])  {\nupdateSupplier(id: $id, supplierInput: $supplierInput, locationsInput: $locationsInput)  {\n...SupplierFragment   \n}\n\n}\n",
  ""
], query);

function parse$2(value) {
  let value$1 = value.updateSupplier;
  return {
    updateSupplier: parse(value$1)
  };
}

function serialize$2(value) {
  let value$1 = value.updateSupplier;
  let updateSupplier = serialize(value$1);
  return {
    updateSupplier: updateSupplier
  };
}

function serializeInputObjectInputUpdateOrCreateSupplierLocation(inp) {
  let a = inp.id;
  let a$1 = inp.recipient;
  let a$2 = inp.address;
  let a$3 = inp.postalCode;
  let a$4 = inp.city;
  let a$5 = inp.country;
  let a$6 = inp.defaults;
  return {
    id: a !== undefined ? a : undefined,
    label: inp.label,
    recipient: a$1 !== undefined ? a$1 : undefined,
    address: a$2 !== undefined ? a$2 : undefined,
    postalCode: a$3 !== undefined ? a$3 : undefined,
    city: a$4 !== undefined ? a$4 : undefined,
    country: a$5 !== undefined ? a$5 : undefined,
    defaults: a$6.map(b => {
      if (b === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    })
  };
}

function serializeInputObjectInputUpdateSupplier(inp) {
  let a = inp.companyName;
  let a$1 = inp.intraCommunityVat;
  let a$2 = inp.siretNumber;
  let a$3 = inp.phoneNumber;
  let a$4 = inp.mobileNumber;
  let a$5 = inp.email;
  let a$6 = inp.note;
  let a$7 = inp.internalCode;
  return {
    companyName: a !== undefined ? a : undefined,
    intraCommunityVat: a$1 !== undefined ? a$1 : undefined,
    siretNumber: a$2 !== undefined ? a$2 : undefined,
    phoneNumber: a$3 !== undefined ? a$3 : undefined,
    mobileNumber: a$4 !== undefined ? a$4 : undefined,
    email: a$5 !== undefined ? a$5 : undefined,
    note: a$6 !== undefined ? a$6 : undefined,
    internalCode: a$7 !== undefined ? a$7 : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.locationsInput;
  return {
    id: inp.id,
    supplierInput: serializeInputObjectInputUpdateSupplier(inp.supplierInput),
    locationsInput: a !== undefined ? a.map(serializeInputObjectInputUpdateOrCreateSupplierLocation) : undefined
  };
}

function makeVariables$1(id, supplierInput, locationsInput, param) {
  return {
    id: id,
    supplierInput: supplierInput,
    locationsInput: locationsInput
  };
}

function makeInputObjectInputUpdateSupplier(companyName, intraCommunityVat, siretNumber, phoneNumber, mobileNumber, email, note, internalCode, param) {
  return {
    companyName: companyName,
    intraCommunityVat: intraCommunityVat,
    siretNumber: siretNumber,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    email: email,
    note: note,
    internalCode: internalCode
  };
}

function makeInputObjectInputUpdateOrCreateSupplierLocation(id, label, recipient, address, postalCode, city, country, defaults, param) {
  return {
    id: id,
    label: label,
    recipient: recipient,
    address: address,
    postalCode: postalCode,
    city: city,
    country: country,
    defaults: defaults
  };
}

let SupplierUpdateMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateSupplier: serializeInputObjectInputUpdateSupplier,
  serializeInputObjectInputUpdateOrCreateSupplierLocation: serializeInputObjectInputUpdateOrCreateSupplierLocation,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateSupplier: makeInputObjectInputUpdateSupplier,
  makeInputObjectInputUpdateOrCreateSupplierLocation: makeInputObjectInputUpdateOrCreateSupplierLocation
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let SupplierUpdateMutation_useWithVariables = include$1.useWithVariables;

let SupplierUpdateMutation = {
  SupplierUpdateMutation_inner: SupplierUpdateMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateSupplier: serializeInputObjectInputUpdateSupplier,
  serializeInputObjectInputUpdateOrCreateSupplierLocation: serializeInputObjectInputUpdateOrCreateSupplierLocation,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateSupplier: makeInputObjectInputUpdateSupplier,
  makeInputObjectInputUpdateOrCreateSupplierLocation: makeInputObjectInputUpdateOrCreateSupplierLocation,
  use: use$1,
  useWithVariables: SupplierUpdateMutation_useWithVariables
};

function get(values, field) {
  switch (field) {
    case "LocationId" :
      return values.locationId;
    case "LocationLabel" :
      return values.locationLabel;
    case "LocationRecipient" :
      return values.locationRecipient;
    case "LocationAddress" :
      return values.locationAddress;
    case "LocationPostalCode" :
      return values.locationPostalCode;
    case "LocationCity" :
      return values.locationCity;
    case "LocationCountry" :
      return values.locationCountry;
  }
}

function set(values, field, value) {
  switch (field) {
    case "LocationId" :
      return {
        locationId: value,
        locationLabel: values.locationLabel,
        locationRecipient: values.locationRecipient,
        locationAddress: values.locationAddress,
        locationPostalCode: values.locationPostalCode,
        locationCity: values.locationCity,
        locationCountry: values.locationCountry
      };
    case "LocationLabel" :
      return {
        locationId: values.locationId,
        locationLabel: value,
        locationRecipient: values.locationRecipient,
        locationAddress: values.locationAddress,
        locationPostalCode: values.locationPostalCode,
        locationCity: values.locationCity,
        locationCountry: values.locationCountry
      };
    case "LocationRecipient" :
      return {
        locationId: values.locationId,
        locationLabel: values.locationLabel,
        locationRecipient: value,
        locationAddress: values.locationAddress,
        locationPostalCode: values.locationPostalCode,
        locationCity: values.locationCity,
        locationCountry: values.locationCountry
      };
    case "LocationAddress" :
      return {
        locationId: values.locationId,
        locationLabel: values.locationLabel,
        locationRecipient: values.locationRecipient,
        locationAddress: value,
        locationPostalCode: values.locationPostalCode,
        locationCity: values.locationCity,
        locationCountry: values.locationCountry
      };
    case "LocationPostalCode" :
      return {
        locationId: values.locationId,
        locationLabel: values.locationLabel,
        locationRecipient: values.locationRecipient,
        locationAddress: values.locationAddress,
        locationPostalCode: value,
        locationCity: values.locationCity,
        locationCountry: values.locationCountry
      };
    case "LocationCity" :
      return {
        locationId: values.locationId,
        locationLabel: values.locationLabel,
        locationRecipient: values.locationRecipient,
        locationAddress: values.locationAddress,
        locationPostalCode: values.locationPostalCode,
        locationCity: value,
        locationCountry: values.locationCountry
      };
    case "LocationCountry" :
      return {
        locationId: values.locationId,
        locationLabel: values.locationLabel,
        locationRecipient: values.locationRecipient,
        locationAddress: values.locationAddress,
        locationPostalCode: values.locationPostalCode,
        locationCity: values.locationCity,
        locationCountry: value
      };
  }
}

let SupplierEditFormLenses_ = {
  get: get,
  set: set
};

let SupplierEditFormLenses = {
  get: get,
  set: set
};

let SupplierEditForm = Form.Make(SupplierEditFormLenses);

let supplierEditFormInitialValues = {
  locationId: "",
  locationLabel: "",
  locationRecipient: "",
  locationAddress: "",
  locationPostalCode: "",
  locationCity: "",
  locationCountry: ""
};

let supplierEditFormSchema = [{
    TAG: "StringNotEmpty",
    _0: "LocationLabel"
  }];

function supplierEditFormInitialValuesFromQueryResult(queryResult) {
  let firstLocation = Stdlib_Option.map(queryResult.locations.edges[0], param => param.node);
  return {
    locationId: Stdlib_Option.mapOr(firstLocation, "", param => param.id),
    locationLabel: Stdlib_Option.mapOr(firstLocation, "", param => param.label),
    locationRecipient: flatMapOrEmptyString(firstLocation, param => param.recipient),
    locationAddress: flatMapOrEmptyString(firstLocation, param => param.address),
    locationPostalCode: flatMapOrEmptyString(firstLocation, param => param.postalCode),
    locationCity: flatMapOrEmptyString(firstLocation, param => param.city),
    locationCountry: flatMapOrEmptyString(firstLocation, param => param.country)
  };
}

function supplierUpdateMutationVariablesFromFormValuesAndQueryResult(formValues, queryResult) {
  return {
    id: queryResult.id,
    supplierInput: makeInputObjectInputUpdateSupplier(queryResult.companyName, queryResult.intraCommunityVat, queryResult.siretNumber, queryResult.phoneNumber, queryResult.mobileNumber, queryResult.email, queryResult.note, queryResult.internalCode, undefined),
    locationsInput: [makeInputObjectInputUpdateOrCreateSupplierLocation(stripEmptyString(formValues.locationId), emptyStringToNull(formValues.locationLabel), emptyStringToNull(formValues.locationRecipient), emptyStringToNull(formValues.locationAddress), emptyStringToNull(formValues.locationPostalCode), emptyStringToNull(formValues.locationCity), emptyStringToNull(formValues.locationCountry), [
        "DELIVERY",
        "BILLING"
      ], undefined)]
  };
}

function SupplierEditLocationPage$SupplierEditFormLocationFieldset(props) {
  let queryResult = props.queryResult;
  let recipientFieldFilledRef = React.useRef(false);
  let dispatch = SupplierEditForm.useFormDispatch();
  let match = SupplierEditForm.useFormState();
  let onChangeLocationAddress = value => dispatch({
    TAG: "FieldValueChanged",
    _0: "LocationAddress",
    _1: param => value
  });
  let onRequestLocationAutoComplete = address => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationAddress",
      _1: param => address.name
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationPostalCode",
      _1: param => address.postcode
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationCity",
      _1: param => address.city
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationCountry",
      _1: param => address.country
    });
  };
  let defaultlocationRecipientFieldPlaceholder = I18n.t("Company name");
  let locationRecipientFieldPlaceholder = !recipientFieldFilledRef.current && queryResult.companyName !== "" ? queryResult.companyName : defaultlocationRecipientFieldPlaceholder;
  let onFocusLocationRecipientField = () => {
    if (!recipientFieldFilledRef.current && locationRecipientFieldPlaceholder !== defaultlocationRecipientFieldPlaceholder) {
      dispatch({
        TAG: "FieldValueChanged",
        _0: "LocationRecipient",
        _1: param => queryResult.companyName
      });
      recipientFieldFilledRef.current = true;
      return;
    }
  };
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Company address"),
    description: I18n.t("Indicate the supplier's address. It will appear on commercial documents."),
    children: [
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "LocationLabel",
        label: I18n.t("Title"),
        placeholder: I18n.t("Invoicing")
      }),
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "LocationRecipient",
        label: I18n.t("Recipient"),
        placeholder: locationRecipientFieldPlaceholder,
        hideRequired: true,
        onFocus: onFocusLocationRecipientField
      }),
      JsxRuntime.jsx(AddressComboBoxField.make, {
        addressName: match.values.locationAddress,
        onInputChange: onChangeLocationAddress,
        onRequestAutoComplete: onRequestLocationAutoComplete
      }),
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "LocationPostalCode",
        label: I18n.t("Postal code"),
        placeholder: I18n.t("Postal code")
      }),
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "LocationCity",
        label: I18n.t("City"),
        placeholder: I18n.t("City")
      }),
      JsxRuntime.jsx(SupplierEditForm.InputCountrySelect.make, {
        field: "LocationCountry"
      })
    ]
  });
}

let SupplierEditFormLocationFieldset = {
  make: SupplierEditLocationPage$SupplierEditFormLocationFieldset
};

function SupplierEditLocationPage$SuppplierEditFormActionsBar(props) {
  let queryResult = props.queryResult;
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let formState = SupplierEditForm.useFormState();
  let match$1 = Navigation.useGoBack();
  let onGoBack = match$1[1];
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      Form__Status.isPristine(formState.status) && match$1[0] ? JsxRuntime.jsx(Button.make, {
          label: I18n.t("Discard"),
          onPress: () => onGoBack()
        }) : JsxRuntime.jsx(SupplierEditForm.CancelButton.make, {
          label: I18n.t("Discard")
        }),
      JsxRuntime.jsx(SupplierEditForm.SubmitButton.make, {
        label: I18n.t("Save"),
        tone: "success",
        onSubmit: (param, values) => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, supplierUpdateMutationVariablesFromFormValuesAndQueryResult(values, queryResult))), undefined, param => param.updateSupplier.id)
      })
    ],
    space: "small"
  });
}

let SuppplierEditFormActionsBar = {
  make: SupplierEditLocationPage$SuppplierEditFormActionsBar
};

function SupplierEditLocationPage(props) {
  let supplierShowRoute = props.supplierShowRoute;
  let navigate = Navigation.useNavigate();
  let asyncQueryResult = AsyncResult.map(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: props.id
  })), result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let supplier = result._0.supplier;
    if (supplier !== undefined) {
      return {
        TAG: "Ok",
        _0: supplier
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
  let match = React.useState(() => {});
  let setNotificationError = match[1];
  let notificationError = match[0];
  let onSubmitFailure = error => setNotificationError(param => error);
  let onSubmitSuccess = response => {
    if (response !== undefined) {
      return navigate({
        replace: true
      }, supplierShowRoute(response));
    } else {
      return setNotificationError(param => Request.serverErrorMessage);
    }
  };
  let formId;
  if (typeof asyncQueryResult !== "object") {
    formId = undefined;
  } else if (asyncQueryResult.TAG === "Reloading") {
    let queryResult = asyncQueryResult._0;
    formId = queryResult.TAG === "Ok" ? queryResult._0.id : undefined;
  } else {
    let queryResult$1 = asyncQueryResult._0;
    formId = queryResult$1.TAG === "Ok" ? queryResult$1._0.id : undefined;
  }
  let formInitialValues;
  if (typeof asyncQueryResult !== "object") {
    formInitialValues = supplierEditFormInitialValues;
  } else if (asyncQueryResult.TAG === "Reloading") {
    let queryResult$2 = asyncQueryResult._0;
    formInitialValues = queryResult$2.TAG === "Ok" ? supplierEditFormInitialValuesFromQueryResult(queryResult$2._0) : supplierEditFormInitialValues;
  } else {
    let queryResult$3 = asyncQueryResult._0;
    formInitialValues = queryResult$3.TAG === "Ok" ? supplierEditFormInitialValuesFromQueryResult(queryResult$3._0) : supplierEditFormInitialValues;
  }
  let formPropState = SupplierEditForm.useFormPropState({
    id: formId,
    initialValues: formInitialValues,
    schema: supplierEditFormSchema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let notificationBanner;
  if (notificationError !== undefined) {
    let onRequestClose = () => setNotificationError(param => {});
    notificationBanner = JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
      value: {
        TAG: "Error",
        _0: notificationError
      },
      onRequestClose: onRequestClose
    });
  } else {
    notificationBanner = null;
  }
  if (typeof asyncQueryResult !== "object") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  if (asyncQueryResult.TAG !== "Done") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  let queryResult$4 = asyncQueryResult._0;
  if (queryResult$4.TAG !== "Ok") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
  let queryResult$5 = queryResult$4._0;
  let actionsBar = JsxRuntime.jsx(SupplierEditLocationPage$SuppplierEditFormActionsBar, {
    queryResult: queryResult$5
  });
  return JsxRuntime.jsx(SupplierEditForm.Core.Provider.make, {
    children: JsxRuntime.jsx(ResourceDetailsPage.make, {
      title: I18n.t("Edition supplier location"),
      subtitle: queryResult$5.companyName,
      actionsBar: actionsBar,
      notificationBanner: notificationBanner,
      children: JsxRuntime.jsx(SupplierEditLocationPage$SupplierEditFormLocationFieldset, {
        queryResult: queryResult$5
      })
    }),
    propState: formPropState
  });
}

let make = SupplierEditLocationPage;

export {
  stripEmptyString,
  flatMapOrEmptyString,
  emptyStringToNull,
  SupplierFragment,
  SupplierQuery,
  SupplierUpdateMutation,
  SupplierEditFormLenses_,
  SupplierEditFormLenses,
  SupplierEditForm,
  supplierEditFormInitialValues,
  supplierEditFormSchema,
  supplierEditFormInitialValuesFromQueryResult,
  supplierUpdateMutationVariablesFromFormValuesAndQueryResult,
  SupplierEditFormLocationFieldset,
  SuppplierEditFormActionsBar,
  make,
}
/* query Not a pure module */
